import { CSSProperties, FunctionComponent, ReactNode } from 'react';
import { SmartTooltip, Text } from '~/commonComponents';
import { Colors } from '~/themes/colors';

interface IProps {
  Anchor: ReactNode;
  style?: Partial<{ container: CSSProperties }>;
}

export const ProfessionalBestInDentalWinnerTooltip: FunctionComponent<IProps> = ({
  Anchor,
  style,
}) => {
  return (
    <SmartTooltip
      content={
        <Text bold color={Colors.white}>
          This professional has earned GoTu’s Best in
          <br />
          Dental badge, our highest recognition for
          <br />
          reliability, professionalism, and excellence in
          <br />
          patient care.
        </Text>
      }
      position="bottom"
      alignment="center"
      trigger="hover"
      style={{ Root: style?.container }}
    >
      {Anchor}
    </SmartTooltip>
  );
};
